import { render, staticRenderFns } from "./AgendaEdit.vue?vue&type=template&id=49788350"
import script from "./AgendaEdit.vue?vue&type=script&lang=js"
export * from "./AgendaEdit.vue?vue&type=script&lang=js"
import style0 from "./AgendaEdit.vue?vue&type=style&index=0&id=49788350&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports